import Usuario from './Usuario'

class Orgao {
    constructor(
        {

            id = null,
            siom_id = null,
            nivel_orgao_siom = null,
            sigla_orgao = null,
            nome_orgao = null,
            ind_ativo = true,
            ind_uso_bhpro = false,
            orgao_id = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            poder = null,

            //ORM
            usuario = {},
            orgao_superior = null,
            agentes_count=null,
        } = {}
    ) {
        this.id = id;

        this.siom_id = siom_id,
        this.nivel_orgao_siom = nivel_orgao_siom,
        this.sigla_orgao = sigla_orgao,
        this.nome_orgao = nome_orgao,
        this.ind_ativo = ind_ativo,
        this.ind_uso_bhpro = ind_uso_bhpro ? ind_uso_bhpro : false,
        this.orgao_id = orgao_id,        
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.poder = poder;
        this.agentes_count = agentes_count;
        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.orgao_superior = orgao_superior!=null ? new this.constructor(orgao_superior) : null;
    }

    isSIOM(){   return this.siom_id!=undefined && this.siom_id!=null && this.siom_id!=''    }

    descPoder(){   
        var desc;
        switch(this.poder){
            case "M":   desc= "Municipal"; break;
            case "E":   desc= "Estadual"; break;
            case "F":   desc= "Federal"; break;
            default: desc= "";
        }
        return desc;
    }

    descFavorito(){   
        return this.ind_uso_bhpro ? "Sim" : "Não"
    }

    countAgentesRelacionados(){
        return this.agentes_count
    }
}

export default Orgao;